import { ref } from 'vue';
import { defineStore } from 'pinia';

interface ShiftsStoreInterface {
  patientId: number | undefined;
  caregiverId: number | undefined;
  startDateTimeFilter: string | undefined;
  offset: number;
  groupByClass: 'patient' | 'caregiver' | undefined;
  caregiverCareerIn: string[];
}

export const useShiftsStore = defineStore('shifts', () => {
  const patientId = ref<ShiftsStoreInterface['patientId']>(undefined);
  const caregiverId = ref<ShiftsStoreInterface['caregiverId']>(undefined);
  const startDateTimeFilter = ref<ShiftsStoreInterface['startDateTimeFilter']>(undefined);
  const offset = ref<ShiftsStoreInterface['offset']>(0);
  const groupByClass = ref<ShiftsStoreInterface['groupByClass']>(undefined);
  const caregiverCareerIn = ref<ShiftsStoreInterface['caregiverCareerIn']>([]);

  return {
    patientId,
    caregiverId,
    startDateTimeFilter,
    offset,
    groupByClass,
    caregiverCareerIn,
  };
}, { persist: true });
